const MINT = "#4ff2c2";
const ROWS = [
  ["The job", "Fix the performance of the same actor: smile, blink, gaze, brows, small head moves", "Swap in a different person from a portrait photo"],
  ["Pixels", "Your own full-resolution pixels. Only the face area is touched", "Every frame regenerated by AI"],
  ["Resolution", "Same as your footage: HD, 4K, 6K and beyond", "Usually capped at 768p or 1080p"],
  ["Length", "Up to 3000 frames, processed only around your edits", "Short clips, typically 5 to 30 seconds per job"],
  ["Control", "Keyframed sliders, drag handles on the face, blink tools", "A photo and an optional prompt, then Generate"],
  ["Cost", "Blink removal is free. Other edits process only short face clips", "Billed per second of regenerated video"],
  ["Where", "Color and Edit pages (OFX), plus Fusion", "Mostly Fusion nodes or web apps"],
];

export const RecastVsSwap = () => (
  <div className="border border-[#2a2f3d] bg-[#0e1013]" data-testid="recast-vs-swap">
    <div className="p-4 border-b border-[#2a2f3d]">
      <h3 className="font-display uppercase text-xl">KolorKlinic Recast vs AI actor replacement</h3>
      <p className="text-sm text-[#9ba3b4] mt-1">Actor-replacement models (some are even called "Recast") make a new person. KolorKlinic Recast is a finishing tool: same actor, better take, delivery quality.</p>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="text-left font-mono text-[11px] uppercase tracking-widest text-[#5c6479]">
            <th className="p-3 w-32" />
            <th className="p-3" style={{ color: MINT }}>KolorKlinic Recast</th>
            <th className="p-3">AI actor replacement</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([k, ours, theirs]) => (
            <tr key={k} className="border-t border-[#1d212b]" data-testid={`recast-vs-row-${k.split(" ")[0].toLowerCase()}`}>
              <td className="p-3 font-display uppercase text-[#9ba3b4]">{k}</td>
              <td className="p-3 text-white">{ours}</td>
              <td className="p-3 text-[#9ba3b4]">{theirs}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
